"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseText = parseText;
exports.validateNDC = validateNDC;
exports.createNewMedication = createNewMedication;
// Helper function to clean and normalize OCR text
function cleanOCRText(text) {
    return text
        // Remove common OCR artifacts
        .replace(/[^\x20-\x7E\n]/g, '') // Remove non-printable characters
        .replace(/\s+/g, ' ') // Normalize whitespace
        .replace(/\n\s*\n/g, '\n') // Remove empty lines
        .replace(/\|\s*/g, ' ') // Remove pipe characters
        .replace(/[%$#@*]/g, ' ') // Remove common OCR artifacts
        .replace(/\s+/g, ' ') // Normalize spaces again
        .trim();
}
// Helper function to extract phone numbers
function extractPhoneNumbers(text) {
    var phonePatterns = [
        /\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})/g, // (123) 456-7890 or 123-456-7890
        /(\d{3})[\s.-]?(\d{3})[\s.-]?(\d{4})/g, // 123 456 7890
    ];
    var phones = [];
    for (var _i = 0, phonePatterns_1 = phonePatterns; _i < phonePatterns_1.length; _i++) {
        var pattern = phonePatterns_1[_i];
        var matches = text.matchAll(pattern);
        for (var _a = 0, matches_1 = matches; _a < matches_1.length; _a++) {
            var match = matches_1[_a];
            var phone = "".concat(match[1], "-").concat(match[2], "-").concat(match[3]);
            if (!phones.includes(phone)) {
                phones.push(phone);
            }
        }
    }
    return phones;
}
// Helper function to extract prescriber information
function extractPrescriberInfo(text) {
    var prescriberInfo = {};
    // Clean the text first
    var cleanText = cleanOCRText(text);
    var lines = cleanText.split('\n');
    // Extract prescriber name patterns
    var namePatterns = [
        /dr\.?\s*([a-z\s]+)/i, // Dr. NAME
        /(?:prescribed by|prescriber|doctor)[:\s]*([a-z\s]+)/i, // Prescribed by: NAME
        /([a-z]+\s+[a-z]+)(?:\s+[a-z]+)?\s*,\s*[a-z]+/i, // LASTNAME, FIRSTNAME
        /dr\.?([a-z]+)\s*,\s*([a-z]+)/i, // DR.KLINE, MITCHELL
        /dr\.?([a-z]+)\s+([a-z]+)/i, // DR KLINE MITCHELL
        /([a-z]+)\s*,\s*([a-z]+)/i, // KLINE, MITCHELL
    ];
    for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
        var line = lines_1[_i];
        for (var _a = 0, namePatterns_1 = namePatterns; _a < namePatterns_1.length; _a++) {
            var pattern = namePatterns_1[_a];
            var match = line.match(pattern);
            if (match && !prescriberInfo.name) {
                var name = '';
                if (match.length === 3) {
                    // Handle "DR.KLINE, MITCHELL" format
                    name = "".concat(match[1], " ").concat(match[2]).trim();
                }
                else {
                    name = match[1].trim().replace(/\s+/g, ' ');
                }
                if (name.length > 2 && name.length < 50) {
                    // Clean up the name
                    name = name.replace(/[^\w\s]/g, ' ').replace(/\s+/g, ' ').trim();
                    prescriberInfo.name = name;
                    console.log('Found prescriber name:', name);
                    break;
                }
            }
        }
    }
    // Extract phone numbers
    var phones = extractPhoneNumbers(cleanText);
    if (phones.length > 0) {
        // Try to find the prescriber's phone number (usually the second phone number)
        if (phones.length >= 2) {
            prescriberInfo.phone = phones[1]; // Second phone number is often the prescriber's
        }
        else {
            prescriberInfo.phone = phones[0];
        }
        console.log('Found prescriber phone:', prescriberInfo.phone);
    }
    // Extract address (look for lines with street addresses)
    for (var _b = 0, lines_2 = lines; _b < lines_2.length; _b++) {
        var line = lines_2[_b];
        if (line.match(/\d+\s+[a-z\s]+(?:street|st|avenue|ave|road|rd|boulevard|blvd)/i)) {
            prescriberInfo.address = line.trim();
            console.log('Found prescriber address:', prescriberInfo.address);
            break;
        }
    }
    return prescriberInfo;
}
// Helper function to extract RX number from text
function extractRXNumber(text) {
    console.log('Extracting RX number from text:', text);
    var rxPatterns = [
        /rx\s*:?\s*#?\s*(\d{6,10})/i, // Rx:989928, RX: 989928, Rx #989928
        /rx\s*#?\s*(\d{6,10})/i, // Rx 989928, RX #989928
        /rx\s*number\s*:?\s*(\d{6,10})/i, // Rx Number: 989928
        /prescription\s*#?\s*:?\s*(\d{6,10})/i, // Prescription: 989928
        /script\s*#?\s*:?\s*(\d{6,10})/i, // Script: 989928
        /(\d{6,10})/ // Fallback: any 6-10 digit number
    ];
    for (var i = 0; i < rxPatterns.length; i++) {
        var pattern = rxPatterns[i];
        var match = text.match(pattern);
        if (match) {
            console.log("RX pattern ".concat(i + 1, " matched:"), match[1]);
            // Additional validation for the fallback pattern
            if (pattern.source === '(\\d{6,10})') {
                var lowerText = text.toLowerCase();
                // Skip if it's likely part of another field
                if (lowerText.includes('ndc') || lowerText.includes('phone') ||
                    lowerText.includes('zip') || lowerText.includes('date') ||
                    lowerText.includes('qty') || lowerText.includes('quantity') ||
                    lowerText.includes('auth') || lowerText.includes('copay') ||
                    lowerText.includes('refill') || lowerText.includes('until')) {
                    console.log('Skipping fallback pattern - likely part of another field');
                    continue;
                }
            }
            console.log('Found RX number:', match[1]);
            return match[1];
        }
    }
    console.log('No RX number found in text');
    return null;
}
function parseText(text) {
    console.log('=== Starting text parsing ===');
    if (!text.trim()) {
        console.log('Empty text received');
        return createNewMedication();
    }
    console.log('Raw OCR text:', text);
    var info = {
        medicationDetails: ''
    };
    // Clean the OCR text first
    var cleanText = cleanOCRText(text);
    console.log('Cleaned OCR text:', cleanText);
    // Split text into lines for processing
    var lines = cleanText.split('\n');
    console.log('Split lines:', lines);
    // Extract prescriber information first
    var prescriberInfo = extractPrescriberInfo(cleanText);
    if (prescriberInfo.name) {
        info.prescriberInfo = prescriberInfo.name;
        console.log('Extracted prescriber name:', prescriberInfo.name);
    }
    if (prescriberInfo.phone) {
        info.pharmacyPhone = prescriberInfo.phone;
        console.log('Extracted prescriber phone:', prescriberInfo.phone);
    }
    if (prescriberInfo.address) {
        info.pharmacyAddress = prescriberInfo.address;
        console.log('Extracted prescriber address:', prescriberInfo.address);
    }
    // Process each line
    for (var _i = 0, lines_3 = lines; _i < lines_3.length; _i++) {
        var line = lines_3[_i];
        var trimmedLine = line.trim();
        if (!trimmedLine)
            continue;
        console.log('Processing line:', trimmedLine);
        // Extract NDC number
        var ndcMatch = trimmedLine.match(/NDC[:\s]*(\d{5}[-\s]?\d{4}[-\s]?\d{2})/i);
        if (ndcMatch) {
            console.log('Found NDC:', ndcMatch[1]);
            info.ndcNumber = ndcMatch[1].replace(/\s/g, '-');
        }
        // Extract medication name and dosage
        var medMatch = trimmedLine.match(/([A-Za-z]+(?:\s+[A-Za-z]+)*)\s+(\d+(?:\.\d+)?\s*(?:mg|mcg|g|ml))/i);
        if (medMatch && !info.medicationName) {
            console.log('Found medication and dosage:', medMatch[1], medMatch[2]);
            info.medicationName = medMatch[1].trim();
            info.dosage = medMatch[2].trim();
        }
        // Extract quantity
        var qtyMatch = trimmedLine.match(/(?:qty|quantity)[:\s]*(\d+)/i) ||
            trimmedLine.match(/(\d+)\s*(?:tablets?|capsules?|pills?)/i);
        if (qtyMatch) {
            console.log('Found quantity:', qtyMatch[1]);
            info.quantity = qtyMatch[1];
        }
        // Extract RX number using the helper function
        if (!info.rxNumber) {
            var rxNumber = extractRXNumber(trimmedLine);
            if (rxNumber) {
                console.log('Found RX number:', rxNumber);
                info.rxNumber = rxNumber;
            }
        }
        // Extract route of administration
        if (trimmedLine.match(/oral|by mouth/i)) {
            console.log('Found route: Oral');
            info.route = 'Oral';
        }
        if (trimmedLine.match(/topical/i)) {
            console.log('Found route: Topical');
            info.route = 'Topical';
        }
        if (trimmedLine.match(/subcutaneous/i)) {
            console.log('Found route: Subcutaneous');
            info.route = 'Subcutaneous';
        }
        if (trimmedLine.match(/intramuscular/i)) {
            console.log('Found route: Intramuscular');
            info.route = 'Intramuscular';
        }
        if (trimmedLine.match(/intravenous/i)) {
            console.log('Found route: Intravenous');
            info.route = 'Intravenous';
        }
        // Extract pharmacy information
        var pharmacyMatch = trimmedLine.match(/pharmacy[:\s]*(.*)/i);
        if (pharmacyMatch) {
            console.log('Found pharmacy:', pharmacyMatch[1]);
            info.pharmacy = pharmacyMatch[1].trim();
        }
    }
    // If RX number wasn't found in individual lines, try the entire text
    if (!info.rxNumber) {
        console.log('RX number not found in individual lines, trying full text...');
        var rxNumber = extractRXNumber(cleanText);
        if (rxNumber) {
            console.log('Found RX number in full text:', rxNumber);
            info.rxNumber = rxNumber;
        }
    }
    // Additional RX number extraction attempts with different approaches
    if (!info.rxNumber) {
        console.log('Trying additional RX number extraction approaches...');
        // Try to find RX numbers in common formats that might have been missed
        var additionalRXPatterns = [
            /(\d{6,10})/g, // Any 6-10 digit number
        ];
        for (var _a = 0, additionalRXPatterns_1 = additionalRXPatterns; _a < additionalRXPatterns_1.length; _a++) {
            var pattern = additionalRXPatterns_1[_a];
            var matches = cleanText.matchAll(pattern);
            for (var _b = 0, matches_2 = matches; _b < matches_2.length; _b++) {
                var match = matches_2[_b];
                var potentialRX = match[1];
                var context = cleanText.substring(Math.max(0, match.index - 20), match.index + 30);
                console.log('Potential RX number found:', potentialRX, 'Context:', context);
                // Validate the potential RX number
                var lowerContext = context.toLowerCase();
                if (!lowerContext.includes('ndc') &&
                    !lowerContext.includes('phone') &&
                    !lowerContext.includes('zip') &&
                    !lowerContext.includes('date') &&
                    !lowerContext.includes('qty') &&
                    !lowerContext.includes('quantity') &&
                    !lowerContext.includes('auth') &&
                    !lowerContext.includes('copay') &&
                    !lowerContext.includes('refill') &&
                    !lowerContext.includes('until') &&
                    !lowerContext.includes('pharmacy') &&
                    !lowerContext.includes('prescriber')) {
                    console.log('Validated RX number:', potentialRX);
                    info.rxNumber = potentialRX;
                    break;
                }
            }
            if (info.rxNumber)
                break;
        }
    }
    // Build medication details string with clear formatting
    console.log('Building medication details string');
    var details = '';
    // Add a header
    details += '=== MEDICATION INFORMATION ===\n\n';
    if (info.medicationName && info.dosage) {
        details += "Medication: ".concat(info.medicationName, " ").concat(info.dosage, "\n");
    }
    if (info.ndcNumber) {
        details += "NDC Number: ".concat(info.ndcNumber, "\n");
    }
    if (info.rxNumber) {
        details += "RX Number: ".concat(info.rxNumber, "\n");
    }
    if (info.quantity) {
        details += "Quantity: ".concat(info.quantity, "\n");
    }
    if (info.route) {
        details += "Route: ".concat(info.route, "\n");
    }
    // Add prescriber information section
    if (info.prescriberInfo || info.pharmacyPhone || info.pharmacyAddress) {
        details += '\n=== PRESCRIBER INFORMATION ===\n';
        if (info.prescriberInfo) {
            details += "Name: ".concat(info.prescriberInfo, "\n");
        }
        if (info.pharmacyPhone) {
            details += "Phone: ".concat(info.pharmacyPhone, "\n");
        }
        if (info.pharmacyAddress) {
            details += "Address: ".concat(info.pharmacyAddress, "\n");
        }
    }
    info.medicationDetails = details.trim();
    console.log('=== Final extracted info ===');
    console.log('Medication Name:', info.medicationName);
    console.log('Dosage:', info.dosage);
    console.log('NDC:', info.ndcNumber);
    console.log('RX Number:', info.rxNumber);
    console.log('Quantity:', info.quantity);
    console.log('Route:', info.route);
    console.log('Prescriber Name:', info.prescriberInfo);
    console.log('Prescriber Phone:', info.pharmacyPhone);
    console.log('Prescriber Address:', info.pharmacyAddress);
    console.log('============================');
    return info;
}
function validateNDC(ndc) {
    // Remove any spaces or hyphens
    var cleanNdc = ndc.replace(/[-\s]/g, '');
    return /^\d{10,11}$/.test(cleanNdc);
}
function createNewMedication() {
    return {
        medicationDetails: '',
        medicationName: '',
        dosage: '',
        ndcNumber: '',
        route: '',
        quantity: '',
        rxNumber: '',
        fillDate: '',
        refills: '',
        expirationDate: '',
        pharmacy: '',
        pharmacyAddress: '',
        pharmacyPhone: '',
        pharmacyDea: '',
        prescriberInfo: '',
        prescriberDeaNpi: '',
        authNumber: ''
    };
}
